<div
  class="
  cg-icon-shape__triangle
  cg-icon-shape__triangle--size-{{ size }}
  cg-icon-shape__triangle--color-{{ color }}
  cg-icon-shape__triangle--direction-{{ direction }}
  "
></div>
